import userApi from './user-api';

export * from './models';

export default userApi;
